// (B) Plain(플레인) Checkbox 백엔드 — antd Checkbox 대체. antd Checkbox v5(rc-checkbox) DOM 이중클래스 미러링:
//   <label.om-checkbox-wrapper/.om-checkbox-wrapper(+-checked/-disabled)>
//     <span.om-checkbox/.om-checkbox(+-checked/-disabled/-indeterminate)>
//       <input.om-checkbox-input/.om-checkbox-input> <span.om-checkbox-inner/.om-checkbox-inner/>
//     </span> {children && <span.om-checkbox-label/.om-checkbox-label>}
//   → 소비처 커스텀 svg SCSS(.om-checkbox-inner::after)·ninegqlUI(antd Checkbox 직접 렌더 공유표면)·
//     ThreadList JS(closest('.om-checkbox-wrapper')) 전량 무변경 매칭(rename batch9 유예).
//   시각 base 는 styles/omwCheckbox.css(:where 0-특이도, 소비처 커스텀 svg 가 항상 우선).
import { useEffect, useRef, useState, type ChangeEvent } from 'react'
import type { OmwCheckboxProps } from '../api/OmwCheckbox'
import { cx } from './cx'
import '../styles/omwCheckbox.css'

export function PlainCheckbox({
  checked,
  indeterminate = false,
  onChange,
  onChangeEvent,
  disabled = false,
  tabIndex,
  children,
  className,
  style,
  'data-testid': dataTestid,
}: OmwCheckboxProps) {
  const isControlled = checked !== undefined
  const [innerChecked, setInnerChecked] = useState(false)
  const currentChecked = isControlled ? checked : innerChecked
  const inputRef = useRef<HTMLInputElement>(null)

  // indeterminate 는 DOM 프로퍼티(속성 아님) — antd 와 동일하게 ref 로 반영.
  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate
  }, [indeterminate])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (disabled) return
    if (!isControlled) setInnerChecked(e.target.checked)
    onChange?.(e.target.checked)
    onChangeEvent?.(e)
  }

  return (
    <label
      className={cx(
        'om-checkbox-wrapper',
        currentChecked && 'om-checkbox-wrapper-checked',
        disabled && 'om-checkbox-wrapper-disabled',
        className,
      )}
      style={style}
      data-testid={dataTestid}
    >
      <span
        className={cx(
          'om-checkbox',
          currentChecked && 'om-checkbox-checked',
          indeterminate && 'om-checkbox-indeterminate',
          disabled && 'om-checkbox-disabled',
        )}
      >
        <input
          ref={inputRef}
          type="checkbox"
          className="om-checkbox-input"
          checked={currentChecked}
          disabled={disabled}
          tabIndex={tabIndex}
          onChange={handleChange}
        />
        <span className="om-checkbox-inner" />
      </span>
      {children !== undefined && children !== null && (
        <span className="om-checkbox-label">{children}</span>
      )}
    </label>
  )
}
